import { createContext } from 'react';
export var GradebookConfigContext = /*#__PURE__*/createContext(null);